export default "<div class=\"divider\">\r\n    <label *ngIf='forminput' [attr.for]=\"forminput.ID\">{{forminput.label}}</label>\r\n</div>"